import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';

export default class NewInvoice extends Component {
    render() {
        const customer_id = this.props.customer;
        if(customer_id)
            return (
                <NavLink className={'btn btn-primary'} to={`/customer/${customer_id}/invoices/new`}>
                    Neue Rechnung
                </NavLink>
            )
        return (
            <NavLink className={'btn btn-primary'} to='/invoices/new'>
                Neue Rechnung erstellen
            </NavLink>
        )
    }
}
